import { OutlinedInput } from "@mui/material";

import "./custom-input.scss";

/* eslint-disable-next-line */
export interface CustomInputProps {
  //react-hook-form props
  register?: any;
  getFieldState?: any;
  formState?: any;
  errors?: any;
  //input props
  name: string;
  value?: string;
  label?: string;
  placeholder?: string;
  assistiveText?: string;
  iconButton?: string;
  actionIconButton?: () => void;
  type?: string;
  required?: boolean;
  validationIcons?: boolean;
  maxLength?: number;
  disabled?: boolean;
  onBlur?: (e?: any) => void;
  onFocus?: (e?: any) => void;
  min?: number;
  max?: number;
  step?: number | string;
  mask?: (value: string) => string;
}

export function CustomInput(props: CustomInputProps) {
  const { validationIcons = true } = props;
  const { isDirty, isTouched } = props.getFieldState(
    props.name,
    props.formState
  );
  const registered = props.register && props.register(props.name);

  return (
    <div className="input-container">
      {props.register && (
        <OutlinedInput
          defaultValue={props.value}
          type={props.type}
          placeholder=""
          className={`custom-input
          ${props.getFieldState(props.name).invalid && "invalid"}
          ${
            !props.getFieldState(props.name).invalid &&
            (isDirty || props.value) &&
            "valid"
          }
          `}
          onFocus={(e) => {
            e.target.placeholder = props.placeholder ? props.placeholder : "";
          }}
          {...registered}
          onChange={(e) => {
            if (props.mask) e.target.value = props.mask(e.target.value);
            registered.onChange(e);
          }}
          onBlur={(e) => {
            e.target.placeholder = "";
            if (props.onBlur) props.onBlur(e);
          }}
          onFocusCapture={props.onFocus}
          autoComplete="off"
          disabled={props.disabled}
          inputProps={{
            maxLength: props.maxLength,
            min: props.min,
            max: props.max,
            step: props.step,
          }}
        ></OutlinedInput>
      )}
      {/* {!props.register && (
        <input
          type={props.type}
          placeholder=""
          className={`custom-input
          ${props.getFieldState(props.name).invalid && "invalid"}
          ${
            !props.getFieldState(props.name).invalid &&
            (isDirty || props.value) &&
            "valid"
          }
          `}
          onFocus={(e) => {
            e.target.placeholder = props.placeholder ? props.placeholder : "";
          }}
          onBlur={(e) => {
            e.target.placeholder = "";
          }}
          autoComplete="off"
          maxLength={props.maxLength}
          disabled={props.disabled}
        ></input>
      )} */}

      {props.label && (
        <label
          className={`input-label ${props.disabled && "disabled"} ${
            isDirty || props.value ? "filled" : ""
          }`}
        >
          {props.label}
          {props.required && <span>*</span>}
        </label>
      )}
      {props.iconButton && (
        <i
          className={` ${props.iconButton} icon-action`}
          onClick={() => {
            if (props.actionIconButton) props.actionIconButton();
          }}
        ></i>
      )}
      {props.assistiveText && (
        <p className="assistive-text">{props.assistiveText}</p>
      )}
      {props.errors &&
        !props.disabled &&
        props.errors[props.name] &&
        !props.iconButton &&
        !!validationIcons && (
          <i className="bi bi-exclamation-triangle-fill icon-error"></i>
        )}
      {props.errors && props.errors[props.name] && (
        <p className="error">{props.errors[props.name]?.message?.toString()}</p>
      )}
      {props.errors &&
        !props.errors[props.name] &&
        (isDirty || props.value) &&
        !props.iconButton &&
        !!validationIcons && <i className="bi bi-check-lg icon-success"></i>}
    </div>
  );
}

export default CustomInput;
